import MenuItemCard from "../../components/public/MenuItemCard";

function MenuCategorySection({ categoryName, items, onAddItem }) {
  return (
    <section className="public-menu-category" aria-labelledby={`category-${categoryName}`}>
      <div className="public-menu-category-heading">
        <h2 id={`category-${categoryName}`}>{categoryName}</h2>
        <span>
          {items.length} item{items.length === 1 ? "" : "s"}
        </span>
      </div>
      <div className="public-card-grid public-card-grid--three">
        {items.map((item) => (
          <MenuItemCard key={item.id} item={item} onAdd={onAddItem} />
        ))}
      </div>
    </section>
  );
}

export default MenuCategorySection;